"use client";
import { PublicationsData } from "@/services/publications/types";
import { useTranslations } from "next-intl";
import Image from "@/components/atoms/image";

export const GalleryGrid = ({ items = [] }: PublicationsData) => {
  const t = useTranslations('Filters');
  return (
    <div className="">
      <div className=" ">
        <span className="text-l-regular text-neutral-900">
          {items?.length} {t("result")}{items?.length > 1 ? "s" : ""}
        </span>
        <div className="mt-32 border-t border-neutral-200" role="separator" aria-hidden="true"></div>
          <div className="pt-32">
            <div className="md:grid grid-cols-2 hidden  gap-x-[26px] gap-y-[32px] ">
              <div>
                {items.length > 0 &&
                  items.map((item, index) => {
                    if (index % 2 !== 0)
                      return (
                        <div key={index} className="flex flex-col  ">
                          <div className="w-full aspect-[1.07] relative overflow-hidden">
                            <Image
                              src={item.featuredImage?.url || ""}
                              alt={item.description || ''}
                              fill
                              className="object-cover"
                            />
                          </div>
                          <div className="flex flex-col gap-2 mb-32">
                            <span className="text-m-regular leadind-[28px] mt-[24px] mb-[8px]">
                              {item.description}
                            </span>
                            <span className="text-l-bold xl:text-xl-bold leadind-[28px] xl:leadind-[28px]">
                              {item.title || ''}
                            </span>
                          </div>
                        </div>
                      );

                    if (index % 10 === 0 && index !== 0)
                      return (
                        <div key={index} className="flex flex-col  ">
                          <div className="w-full aspect-[1.06] relative overflow-hidden">
                            <Image
                              src={item.featuredImage?.url || ""}
                              alt={item.description || ''}
                              fill
                              className="object-cover"
                            />
                          </div>
                          <div className="flex flex-col gap-2 mb-32">
                            <span className="text-m-regular leadind-[28px] mt-[24px] mb-[8px]">
                              {item.description}
                            </span>
                            <span className="text-l-bold xl:text-xl-bold leadind-[28px] xl:leadind-[28px]">
                              {item.title}
                            </span>
                          </div>
                        </div>
                      );
                  })}
              </div>

              <div>
                {items.length > 0 &&
                  items
                    .filter(
                      (e, index) =>
                        index % 2 === 0 && (index % 10 !== 0 || index === 0)
                    )
                    .map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="hidden md:flex flex-col  "
                        >
                          <div
                            className={`w-full ${
                              index % 2 === 0
                                ? "aspect-[0.68]"
                                : "aspect-[0.76]"
                            } relative overflow-hidden`}
                          >
                            <Image
                              src={item.featuredImage?.url  || ""}
                              alt={item.description || ''}
                              fill
                              className="object-cover"
                            />
                          </div>
                          <div className="flex flex-col gap-2 mb-32 ">
                            <span className="text-m-regular leadind-[28px] mt-[24px] mb-[8px]">
                              {item.description}
                            </span>
                            <span className="text-l-bold xl:text-xl-bold leadind-[28px] xl:leadind-[28px]">
                              {item.title}
                            </span>
                          </div>
                        </div>
                      );
                    })}
              </div>
            </div>

            <div className="md:hidden flex flex-col md:flex-row">
              {items.length > 0 &&
                items.map((item, index) => {


                  if ((index % 2 === 0 ))
                    return (
                      <div key={index} className="flex flex-col  ">
                        <div className="w-full aspect-[1.07] relative overflow-hidden">
                          <Image
                            src={item.featuredImage?.url || ""}
                            alt={item.description || ''}
                            fill
                            className="object-cover"
                          />
                        </div>
                        <div className="flex flex-col gap-2 mb-32">
                          <span className="text-m-regular leadind-[28px] mt-[24px] mb-[8px]">
                            {item.description}
                          </span>
                          <span className="text-l-bold xl:text-xl-bold leadind-[28px] xl:leadind-[28px]">
                            {item.title}
                          </span>
                        </div>
                      </div>
                    );

                  if ((index % 2 !== 0 ))
                    return (
                      <div key={index} className="flex flex-col  ">
                        <div className="w-full aspect-[0.74] relative overflow-hidden">
                          <Image
                            src={item.featuredImage?.url || ""}
                            alt={item.description || ''}
                            fill
                            className="object-cover"
                          />
                        </div>
                        <div className="flex flex-col gap-2 mb-32">
                          <span className="text-m-regular leadind-[28px] mt-[24px] mb-[8px]">
                            {item.description}
                          </span>
                          <span className="text-l-bold xl:text-xl-bold leadind-[28px] xl:leadind-[28px]">
                            {item.title}
                          </span>
                        </div>
                      </div>
                    );

                 
                })}
            </div>
          </div>
        </div>
    </div>
  );
};
